<template>
  <div id="o2o">
    <tabtop></tabtop>
    <div class="o2o1">
        <img :src="url+banner.images[1]" alt=""  @click="jumpbannerpage(banner.url,1)">
    </div>
    <div class="o2o2">
        <ul v-for="(item,index) in o2o2" :key="index" class="wow animate__animated animate__fadeIn">
            <li>
                <img :src="item.img" alt="">
            </li>
            <li>
                <p class="p1">{{item.title}}</p>
                <p class="p2">{{item.subtitle}}</p>
            </li>
        </ul>
    </div>
    <div class="o2o3">
        <div v-for="(item,index) in o2o3" :key="index"  class="wow animate__animated animate__fadeIn">
            <img :src="item" alt="">
        </div>
    </div>
    <div class="o2o4">
        <p class="title">八大应用，全面解决企业客户营销</p>
        <p class="subtitle">/会员各模型打造/用户信息自定义画像/营销策划丰富变化/全方位分析决策/企业连锁财务统一/商品销售爆款分析/沉睡会员分析/</p>
        <img src="@/assets/product/o2o7.png" alt=""  class="wow animate__animated animate__fadeIn">
    </div>
    <div class="o2o4">
        <p class="title">快速构建经销商-总部-会员营销平台</p>
        <img src="@/assets/product/o2o8.png" alt=""  class="wow animate__animated animate__fadeIn">
    </div>
    <div class="o2o4">
        <p class="title">功能特色</p>
        <img src="@/assets/product/o2o9.png" alt=""  class="wow animate__animated animate__fadeIn">
    </div>
    <div class="o2o4">
        <p class="title">会员营销</p>
        <p class="subtitle">做自己的会员营销品台</p>
        <img src="@/assets/product/o2o10.png" alt=""  class="wow animate__animated animate__fadeIn">
    </div>
    <webbottom></webbottom>
  </div>
</template>

<script>
var that
import { rotationmap } from '@/api/api'
import tabtop from '@/components/tab/tab.vue'
import webbottom from '@/components/bottom/bottom.vue'
export default {
    name:"o2o",
    components: {
        tabtop,
        webbottom
    },
    data(){
        return {
            url : window.url,
            banner:{},
            o2o2:[
                {
                    img:require("@/assets/product/o2o1.png"),
                    title:"会员统一",
                    subtitle:"huiyuantongyi"
                },
                {
                    img:require("@/assets/product/o2o2.png"),
                    title:"订单统一",
                    subtitle:"dingdantongyi"
                },
                {
                    img:require("@/assets/product/o2o3.png"),
                    title:"财务统一",
                    subtitle:"caiwutongyi"
                }
            ],
            o2o3:[require("@/assets/product/o2o4.png"),require("@/assets/product/o2o5.png"),require("@/assets/product/o2o6.png")],

            
           
        }
    },
    mounted(){
        that = this
        //初始化动画
        rotationmap({'type':8}).then((response) => {
            response.data.data[0].images = response.data.data[0].images.split(',')
            that.banner = response.data.data[0]
            this.$nextTick(function(){
                if(this.$route.query.id){
                    document.getElementById(this.$route.query.id).scrollIntoView();
                }
                this.$wow.init()
            })
        })
    },
    methods:{
        jumpbannerpage(e,y){
            let url = e.split(';')
            if(url[y] != this.$route.path) {
                this.$router.push(url[y])
            }
        }
    }
}
</script>

<style lang="less">
:root {
    --web-title-fontsize: 30px;
    --web-subtitle-fontsize: 22px;
    --web-text-fontsize: 16px;
} 
@media (min-width:750px) {
    #o2o{
        .o2o1{
            img{
                width: 100%;
            }
        }
        .o2o2{
            width: 1400px;
            margin:-60px auto 30px;
            display: flex;
            justify-content: space-between;
            ul{
                width: 350px;
                height: 115px;
                background: #FFFFFF;
                box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                border-radius: 20px 20px 20px 20px;
                display: flex;
                align-items: center;
                padding: 24px 64px;
                li{
                    img{
                        width: 64px;
                        margin-right: 12px;
                    }
                    .p1{
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: 400;
                        color: #202020;
                    }
                    .p2{
                        font-size: var(--web-text-fontsize);
                        font-weight: normal;
                        color: #696969;
                    }
                }
            }
        }
        .o2o3{
            margin-top: 60px;
            div{
                margin:0 auto 0;
                padding: 50px 0;
                background: linear-gradient(180deg, rgba(218,230,254,0.8) 0%, rgba(194,212,255,0.16) 100%);
                img{
                    display: block;
                    width: 1148px;
                    margin:0 auto;
                }
            }
        }
        .o2o4{
            padding: 40px;
            background: linear-gradient(180deg, #EFF4FF 0%, rgba(197,214,255,0) 100%);
            .title{
                font-size: var(--web-title-fontsize);
                font-family: Source Han Sans CN-Heavy, Source Han Sans CN;
                font-weight: 800;
                color: #020202;
                text-align: center;
                margin-bottom: 40px;
                text-align: center;
            }
            .subtitle{
                font-size: 24px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                text-align: center;
                width: 830px;
                margin:0 auto;
            }
            img{
                width: 1280px;
                display: block;
                margin:60px auto 0;
            }
        }
    }
}
@media screen and (max-width:750px) {
    #o2o{
        .o2o1{
            img{
                width: 100%;
            }
        }
        .o2o2{
            width: 100%;
            margin:-30px auto 30px;
            display: flex;
            justify-content: space-between;
            padding: 0 10px;
            ul{
                background: #FFFFFF;
                box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                border-radius: 20px 20px 20px 20px;
                display: flex;
                align-items: center;
                padding: 12px 12px;
                flex-wrap: wrap;
                flex:0 0 28%;
                li{
                    img{
                        width: 40px;
                        margin-right: 12px;
                    }
                    .p1{
                        font-size: 16px;
                        font-weight: 400;
                        color: #202020;
                    }
                    .p2{
                        font-size: 14px;
                        font-weight: normal;
                        color: #696969;
                    }
                }
            }
        }
        .o2o3{
            width: 100%;
            margin-top: 60px;
            div{
                margin:0 auto 0;
                padding: 50px 0;
                background: linear-gradient(180deg, rgba(218,230,254,0.8) 0%, rgba(194,212,255,0.16) 100%);
                img{
                    display: block;
                    width: 90%;
                    margin:0 auto;
                }
            }
        }
        .o2o4{
            width: 100%;
            padding: 20px;
            background: linear-gradient(180deg, #EFF4FF 0%, rgba(197,214,255,0) 100%);
            .title{
                font-size: var(--web-title-fontsize);
                font-family: Source Han Sans CN-Heavy, Source Han Sans CN;
                font-weight: 800;
                color: #020202;
                text-align: center;
                margin-bottom: 20px;
                text-align: center;
            }
            .subtitle{
                font-size: 24px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                text-align: center;
                width: 90%;
                margin:0 auto;
            }
            img{
                width: 90%;
                display: block;
                margin:30px auto 0;
            }
        }
        
    }
}
</style>